export default __webpack_public_path__ + "static/media/contactUsLogo.c76150df.svg";